module.exports = __webpack_public_path__ + "img/seal.56149758.png";